function batteryColor(v: number): string {
  if (v >= 85) return '#10b981'
  if (v >= 70) return '#3b82f6'
  if (v >= 50) return '#f59e0b'
  return '#ef4444'
}

export function specBatteryColor(v: number): string {
  return batteryColor(v)
}

export function SpecStorageIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 9h6v6H9z" />
      <path d="M4 12H2M22 12h-2" strokeLinecap="round" />
    </svg>
  )
}

export function SpecCalendarIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" strokeLinecap="round" />
    </svg>
  )
}

export function SpecShieldIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinejoin="round" />
    </svg>
  )
}

export function SpecChargeCyclesIcon({ size = 18, color = '#48a0b8' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" aria-hidden>
      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 16H3v5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 8h5V3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function SpecBatteryIcon({ size = 18, level = 100 }: { size?: number; level?: number }) {
  const color = batteryColor(level)
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" aria-hidden>
      <rect x="2" y="7" width="18" height="10" rx="2" />
      <rect x="20" y="10" width="2" height="4" rx="1" fill={color} stroke="none" />
      <rect
        x="4"
        y="9"
        width={Math.max(1, (level / 100) * 14)}
        height="6"
        rx="1"
        fill={color}
        stroke="none"
      />
    </svg>
  )
}
